import { useState } from "react";
import { Ticket } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";

const inp = "w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-2.5 outline-none focus:border-rose-500 text-sm";

export function RsvpDialog({ event, label = "RSVP", onDone, className }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ guest_name: user?.name || "", email: user?.email || "", phone: "", guests: "1", status: "going" });
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const submit = async () => {
    if (!f.guest_name || !f.email) { toast.error("Name and email required"); return; }
    try {
      await api.post("/rsvps", { event_id: event.id, ...f });
      toast.success(`You're ${f.status} to ${event.title}! 🎉`);
      setOpen(false);
      onDone && onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className={className || "w-full bg-rose-500 hover:bg-rose-600 font-bold py-3.5 rounded-xl transition-colors"} data-testid="event-rsvp-btn"><Ticket className="inline mr-2" size={18} />{label}</button>
      </DialogTrigger>
      <DialogContent className="bg-[#111] border-white/10 text-white max-w-md">
        <DialogHeader><DialogTitle className="font-display text-2xl">RSVP to {event.title}</DialogTitle>
          <DialogDescription className="text-zinc-400 text-sm">Reserve your spot — we'll save it{user ? " to your dashboard" : ""}.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <select className={inp} value={f.status} onChange={(e) => set("status", e.target.value)} data-testid="rsvp-status">
            <option value="going">I'm going</option><option value="interested">Interested</option>
          </select>
          <input className={inp} placeholder="Your name" value={f.guest_name} onChange={(e) => set("guest_name", e.target.value)} data-testid="rsvp-name" />
          <input className={inp} placeholder="Email" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="rsvp-email" />
          <input className={inp} placeholder="Phone (optional)" value={f.phone} onChange={(e) => set("phone", e.target.value)} />
          <input type="number" min="1" className={inp} placeholder="Number of guests" value={f.guests} onChange={(e) => set("guests", e.target.value)} data-testid="rsvp-guests" />
          <button onClick={submit} className="w-full bg-rose-500 hover:bg-rose-600 font-bold py-3 rounded-lg" data-testid="rsvp-submit">Confirm RSVP</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
